import { render, staticRenderFns } from "./ViewMethodHeterogeneity.vue?vue&type=template&id=c68fea94&scoped=true"
import script from "./ViewMethodHeterogeneity.vue?vue&type=script&lang=js"
export * from "./ViewMethodHeterogeneity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68fea94",
  null
  
)

export default component.exports